import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const rows = [{
  label: '📘 The 360° Muscle Recovery System™ (6 Volumes, 150+ pages)',
  price: '$19'
}, {
  label: '🎁 Bonus #1: The Hamstring Restoration Protocol',
  price: 'FREE'
}, {
  label: '🎁 Bonus #2: The Lower Back Shield / Lumbar Resilience',
  price: 'FREE'
}, {
  label: '🎁 Bonus #3: The Calf & Achilles Anchor',
  price: 'FREE'
}, {
  label: '🎁 Bonus #4: The Shoulder Armor: Rotator Cuff Matrix',
  price: 'FREE'
}, {
  label: '🎁 Bonus #5: The Groin & Adductor Solution',
  price: 'FREE'
}, {
  label: '🛡️ 7-Day Money-Back Guarantee',
  price: 'INCLUDED'
}, {
  label: '♾️ Lifetime access & free updates',
  price: 'INCLUDED'
}];
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Delivery'
}, {
  icon: ShieldCheckIcon,
  label: '7-Day Guarantee'
}, {
  icon: CreditCardIcon,
  label: 'Debit / Credit'
}];
export function ValueStack() {
  return <section id="value" aria-label="Offer summary" className="border-y border-grape/10 bg-white/70" data-id="element-185" data-mp="1tfmp4sgojx51">
      <div className="mx-auto max-w-2xl px-5 py-12 text-center" style={{
      paddingTop: "13px",
      paddingBottom: "25px"
    }} data-id="element-186" data-mp="1oi3a3qc5rgc1">
        <h2 className="font-display text-2xl font-black text-plum sm:text-4xl" data-id="element-187" data-mp="236zixpm1gxdp">
          🚀 Start Rebuilding Your Muscles Today
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm text-plum/60" data-id="element-188" data-mp="2c4takn8uz2uj">
          Assess properly, load progressively and return to action safely. One single payment,
          lifetime access, everything ready to start today.
        </p>

        <div className="mt-10 overflow-hidden rounded-2xl border border-grape/15 bg-cream text-left" data-id="element-189" data-mp="2m390imw5g62g">
          <div className="flex items-center justify-between border-b border-grape/10 px-5 py-3 text-xs font-bold uppercase tracking-wide text-plum/55" data-id="element-190" data-mp="2h2usv5ygmy4y">
            <span data-id="element-191" data-mp="mrpv2ia21fxj">What's included</span>
            <span data-id="element-192" data-mp="msr3eezorobk">Price</span>
          </div>
          {rows.map(r => <div key={r.label} className="flex items-center justify-between gap-4 border-b border-grape/10 px-5 py-3.5 text-sm" data-id="element-193" data-mp="2mtxsqcfw6kn1">
              <span className="text-plum/80" data-id="element-194" data-mp="2rssglsspuze0">{r.label}</span>
              <span className={r.price.startsWith('$') ? 'shrink-0 font-bold text-plum' : 'shrink-0 font-bold text-grape'} data-id="element-195" data-mp="2vtccyu5gtyz3">
                {r.price}
              </span>
            </div>)}
          <div className="flex flex-col items-center gap-1 bg-lilac-soft px-5 py-6 text-center" data-id="element-196" data-mp="35sa3u3qd64l9">
            <span className="text-sm font-bold text-plum" style={{
            fontSize: "16px"
          }} data-id="element-197" data-mp="3aqv3a0xskk8n">
              Real total value: <span className="text-plum/40 line-through" data-id="element-198" data-mp="3fhl9fge1kr4e">$235</span>
            </span>
            <div className="flex w-full justify-center" style={{
            paddingTop: "9px",
            paddingBottom: "9px"
          }} data-id="element-199" data-mp="3jjyahrhug0uu">
              <span className="relative inline-block font-display leading-none" style={{
              fontFamily: "Montserrat, sans-serif"
            }} data-id="element-200" data-mp="3ojb0gl40ho1n">
                {/* Currency symbol — adjust fontSize here */}
                <span className="text-grape-shine absolute right-full top-1/2 -translate-y-1/2 font-black leading-none" style={{
                fontSize: "40px",
                marginRight: "4px",
                fontFamily: "Merriweather, serif"
              }} data-id="element-201" data-mp="7gycs3z86txr">
                  $
                </span>

                {/* Amount — stays centered on the page */}
                <span className="text-grape-shine font-black leading-none" style={{
                fontSize: "70px",
                fontFamily: "Merriweather, serif"
              }} data-id="element-202" data-mp="q6n1hfchhe4o">
                  19
                </span>

                {/* Currency code — adjust fontSize here */}
                <span className="absolute left-full top-1/2 -translate-y-1/2 font-bold uppercase leading-none tracking-wide text-grape" style={{
                fontSize: "26px",
                marginLeft: "6px",
                fontWeight: "900",
                fontFamily: "Merriweather, serif"
              }} data-id="element-203" data-mp="geqvzj82ilqf">
                  USD
                </span>
              </span>
            </div>
            <span className="text-xs font-semibold uppercase tracking-wide text-plum/60" data-id="element-204" data-mp="omtn1qzjmfiw">
              One-time payment
            </span>
            <span className="mt-1 text-[11px] font-medium text-plum/50" data-id="element-205" data-mp="fnq3klwgry3v">
              Payment will be processed in your local currency.
            </span>
          </div>
        </div>

        <div className="mt-9 flex justify-center" data-id="element-206" data-mp="jr4s60ygxmsx">
          <CTAButton data-id="element-207" data-mp="17fxjtl8258hq">Get The 360° Muscle Recovery System</CTAButton>
        </div>

        <p className="mt-3 text-xs font-semibold text-plum/55" data-id="element-208" data-mp="1ce8qxo6yx4w9">
          You save $216 USD (92% OFF) · One-time payment
        </p>
        

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-plum/55" data-id="element-209" data-mp="ymc33wcc1h5o">
          {trust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-210" data-mp="1qcyp775ixam7">
              <Icon className="h-4 w-4 text-grape" data-id="element-211" data-mp="1v4qfrhoojgcc" />
              {label}
            </span>)}
        </div>
      </div>
    </section>;
}